import script from "./ContactsFoundCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactsFoundCard.vue?vue&type=script&setup=true&lang=ts"

import "./ContactsFoundCard.vue?vue&type=style&index=0&id=75e4e838&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e4e838"]])

export default __exports__